import React from "react";

function NonRecourseLoan() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <div className="breadcrumb_sutitle">
              <h6>INNOVATIVE LOAN STRUCTURE</h6>
            </div>
            <h1 className="breadcrumb_title">Arbitrage / Self Liquidation</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Arbitrage / Self Liquidation Non-Recourse Loan</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Feature Section */}
      <section className="feature_section home_five" data-aos="fade-up">
        <div className="container">
          <div className="row">
            <div className="section_title centred">
              <h2>Arbitrage / Self Liquidation Non-Recourse Loan</h2>
              <p>
                Strategic loan structuring where investments generate returns to
                service loan obligations for Indian and Global market.
              </p>
            </div>
            <div
              className="col-xl-12 col-lg-12 col-md-12"
              data-aos="fade-right"
            >
              <div className="range-box-service">
                <div className="row align-items-center">
                  <div className="col-xl-8 col-lg-8 col-md-12">
                    <h3>CRITICAL RISK WARNING</h3>
                    <p className="mb-2">50 Lacs and Multiple</p>
                    <div className="table_content">
                      <ul className="feature_list text-left">
                        {[
                          "Investment returns are NOT guaranteed",
                          "You remain FULLY LIABLE for loan amount",
                          "Poor performance may affect repayment ability",
                          "Compound risk: investment + debt",
                          "Consult legal & financial advisors before proceeding",
                        ].map((item, index) => (
                          <li className="Coverage-list" key={index}>
                            <i className="fa-solid fa-check"></i>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Loan Structure Section */}
      <section className="service_section pt-5 pb-5" data-aos="fade-up">
        <div className="circle_one"></div>
        <div className="circle_two"></div>
        <div className="container">
          <div className="section_title light centred">
            <h2>Loan Structure Overview</h2>
            <p className="text-white">Understanding the arbitrage mechanism</p>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-12 col-sm-12">
              <div className="service_block_one">
                <div className="profit-range-box">
                  <div className="profit-plan-range">
                    <h5>Loan Source</h5>
                    <h6>
                      Borrower raises loan from Bank, NBFC, or other financial
                      institutions
                    </h6>
                  </div>
                  <div className="profit-plan-range">
                    <h5>Investment Allocation</h5>
                    <h6>
                      50% or more of loan amount invested as per fund manager's
                      strategy
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Details Section */}
      <section className="why_choose_us pt_150 about_page" data-aos="fade-up">
        <div className="container">
          <div className="border_top"></div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="range-box-service p-5 text-center">
                <h3>Complete Service Details</h3>
                <p>
                  Download the full documentation for comprehensive information
                </p>
                <div className="link-btn mt-3">
                  <a
                    href="#"
                    className="btn_style_one"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open Pdf Document
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NonRecourseLoan;
